// REDUCER
import * as actionTypes from '../constants/actions';

const COOKIE_NAME = 'cookies_accepted';
const cookiesAccepted = document.cookie.length > 0 && document.cookie.indexOf(`${COOKIE_NAME}=`) !== -1;

const defaultState = {
	cookiesAccepted,
	showNotice: !cookiesAccepted,
};

function acceptCookies(state) {
	return { ...state, showNotice: false };
}

export default function cookieReducer(state = defaultState, action) {
	switch (action.type) {
		case actionTypes.COOKIES_ACCEPT:
			return acceptCookies(state);
			break;
		default:
			return state;
	}
}



/** WEBPACK FOOTER **
 ** ./frontend/reducers/cookie.js
 **/